/**
 * Created by mohit.chavda on 3/9/2017.
 */
export class Ethnicity {

  get label():string
  {
    return this.ethnicity;
  };
  get value():string
  {
    return this.ethnicity;
  };

  ethnicityID:number;
  ethnicity:string;
  allowCustomInput:boolean;
  sortOrder:number;
}



// WEBPACK FOOTER //
// ./src/app/shared/Ethnicity.ts